import { transformDateValue } from 'core/js/FormUtils';
export const getMfstitchingstatusView = (dataList) => {
  
  const transformDataValue = (value, type) =>{
    if (!type.includes('date')) return value;
    return transformDateValue(value);
  }

  let mfstitchingstatusList = [];
  dataList.map((data)=>{
  let card = {
            'id': data.id,
            'headingList': [
                            {"fieldLabel":"title","fieldValue":transformDataValue(data.title,"string"), "fieldType":"string"},
              
              
            ],
            'dataList': [
                
              ]
          }

          mfstitchingstatusList.push(card);
  })
  return mfstitchingstatusList;
}